import React, { useState } from 'react';
import { useCart } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const MyOrder = () => {
  const {
    cart,
    removeFromCart,
    clearCart,
    balance,
    placeOrder,
    deliveryDate,
    needsCutlery,
    needsBread,
    breadType,
    calculateCustomTotal, // 💡 теперь используем общий расчёт
    editingOrderId, // ID редактируемого заказа
  } = useCart();

  const navigate = useNavigate();
  const [comment, setComment] = useState('');

  const total = calculateCustomTotal(); // ✅ использует общую формулу

  const handleOrder = async () => {
    if (!deliveryDate) {
      alert('❌ Дата доставки не выбрана! Пожалуйста, выберите дату доставки перед оформлением заказа.');
      return;
    }

    if (total > balance) {
      alert('❌ Недостаточно средств на балансе для оформления заказа.');
      return;
    }

    const order = await placeOrder({
      comment,
      cutlery: needsCutlery,
      bread: needsBread,
      breadTypeChoice: breadType,
    });

    if (!order) {
      console.error('Order creation/update failed:', {
        cart,
        deliveryDate,
        total,
        editingOrderId,
        comment,
        needsCutlery,
        needsBread,
        breadType
      });
      alert('❌ Ошибка при оформлении заказа. Проверьте консоль для деталей и попробуйте еще раз.');
      return;
    }

    const isEditing = editingOrderId !== null;
    alert(
      `✅ Заказ успешно ${isEditing ? 'обновлен' : 'оформлен'}!\n\n` +
        `Номер: ${order.shortCode || order.id}\n` +
        `Комментарий: ${order.comment || '—'}\n` +
        `Дата доставки: ${
          deliveryDate ? new Date(deliveryDate).toLocaleDateString('ru-RU') : 'не указана'
        }`
    );

    navigate('/user');
  };

  if (cart.length === 0) {
    return (
      <div className="p-4 text-white text-center text-lg">
        🛒 Ваша корзина пуста
        <div className="mt-4">
          <button
            onClick={() => navigate('/user')}
            className="text-blue-400 hover:text-blue-300 underline text-sm"
          >
            ← Назад к меню
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 max-w-screen-md mx-auto text-white pb-24">
      <button
        onClick={() => navigate('/user')}
        className="mb-4 text-sm text-blue-400 hover:text-blue-300 underline"
      >
        ← Назад к меню
      </button>

      <h2 className="text-2xl font-bold mb-2 text-center">🧾 Ваш заказ</h2>

      {editingOrderId && (
        <div className="text-center mb-4">
          <p className="text-sm text-green-400 bg-green-900 bg-opacity-50 border border-green-700 rounded-lg p-3 inline-block">
            ✅ Редактирование заказа
            <br />
            <span className="text-xs text-gray-300">Цены актуализированы</span>
          </p>
        </div>
      )}

      <p className="text-sm text-center text-gray-300 mb-2">
        📅 Дата доставки:{' '}
        <span className="font-semibold text-teal-400">
          {deliveryDate ? new Date(deliveryDate).toLocaleDateString('ru-RU') : 'не выбрана'}
        </span>
      </p>

      <p className="text-sm text-center text-gray-300 mb-6">
        Баланс:{' '}
        <span
          className={`font-semibold ${
            balance < total ? 'text-red-400' : 'text-green-400'
          }`}
        >
          {balance} ₽
        </span>
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
  {cart.map((item, index) => (
    <motion.div
      key={item.id}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: index * 0.05 }}
      className="bg-gray-800 rounded-xl shadow-xl overflow-hidden transform hover:scale-[1.02] transition"
    >
      <div className="h-36 overflow-hidden relative">
        <img
          src={item.imageUrl || '/placeholder.jpg'}
          alt={item.name}
          className="w-full h-full object-cover hover:scale-105 transition duration-300"
        />
      </div>
      <div className="p-4 space-y-2">
        <h4 className="text-lg font-bold text-white">{item.name}</h4>
        <p className="text-sm text-gray-400">
          Количество: {item.quantity}
        </p>
        <button
          onClick={() => removeFromCart(item.id)}
          className="text-red-400 text-sm hover:text-red-600 transition"
        >
          Удалить
              </button>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="mt-6">
        <label className="block mb-2 text-sm text-gray-300">Комментарий к заказу:</label>
        <textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          className="w-full bg-gray-800 border border-gray-600 text-white rounded-lg p-3 text-sm"
          placeholder="Например: без лука, или оставить у двери"
          rows={3}
        ></textarea>
      </div>

      <div className="mt-8 text-center">
        <p className="text-lg font-semibold">💳 Итого: {total} ₽</p>
      </div>

      <div className="mt-6 flex flex-col sm:flex-row gap-4 justify-center">
        <button
          onClick={clearCart}
          className="bg-gray-700 hover:bg-gray-600 text-white py-2 px-6 rounded-lg shadow-md text-sm transition"
        >
          🗑 Очистить заказ
        </button>

        <button
          onClick={handleOrder}
          disabled={!deliveryDate || total > balance}
          className={`py-2 px-6 rounded-lg shadow-md text-sm transition ${
            !deliveryDate || total > balance
              ? 'bg-gray-500 cursor-not-allowed text-gray-300'
              : 'bg-green-600 hover:bg-green-700 text-white'
          }`}
        >
                     {!deliveryDate 
             ? '❌ Выберите дату доставки' 
             : total > balance 
               ? '❌ Недостаточно средств'
               : editingOrderId 
                 ? '✅ Сохранить изменения'
                 : '✅ Оформить заказ'
           }
        </button>
      </div>
    </div>
  );
};

export default MyOrder;
